import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Heart, Sparkles } from "lucide-react";

const KIND_LABEL = {
  sponsor: "Sponsor",
  strategic_partner: "Strategic Partner",
  media_partner: "Media Partner",
  scholarship_sponsor: "Scholarship Sponsor",
};

// Live thank-you ticker for sponsors / partners / scholarship donors.
// Auto-refreshes every 60s so Backoffice publish actions surface within a minute.
export default function RecognitionWall() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let stop = false;
    const load = async () => {
      try {
        const r = await api.get("/recognition-wall");
        if (!stop) setItems(r.data?.items || []);
      } catch (err) {
        // Non-fatal: keep showing the last known good list. Surface to console
        // so prod issues are still observable.
        console.warn("Failed to refresh recognition wall:", err);
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { stop = true; clearInterval(id); };
  }, []);

  if (items.length === 0) return null;

  // Duplicate the list so the CSS animation loop reads as seamless.
  const loop = [...items, ...items];

  return (
    <section data-testid="recognition-wall" className="relative border-y border-aawta-pink/20 bg-gradient-to-r from-aawta-pink/10 via-transparent to-aawta-pink/10 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-4 flex items-center gap-6">
        <div className="shrink-0 flex items-center gap-2">
          <Heart size={14} className="text-aawta-pink" fill="currentColor" />
          <p className="text-overline text-aawta-pink whitespace-nowrap">THANK YOU</p>
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="recognition-ticker flex gap-8 whitespace-nowrap">
            {loop.map((it, i) => (
              <span
                key={`${it.kind}-${it.name}-${i}`}
                data-testid={`recog-item-${i}`}
                className="inline-flex items-center gap-2 text-sm"
              >
                {it.featured && <Sparkles size={12} className="text-yellow-300" />}
                <span className="text-white font-display">{it.name}</span>
                <span className="text-white/40">·</span>
                <span className="text-overline text-aawta-pink/80">
                  {it.tier ? `${it.tier} ` : ""}{KIND_LABEL[it.kind] || ""}
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
